"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUCTION_CASH_CHEQUE_MINIMUM_AMOUNT = exports.DEFAULT_CHEQUE_MINIMUM_AMOUNT = exports.SEPA_MAX_PAYMENT_AMOUNT = exports.MAX_PAYMENT_AMOUNT_WITHOUT_TIP = exports.DEFAULT_SUGGESTED_AMOUNTS_COUNT = exports.SUGGESTED_AMOUNTS_COUNT_OPTIONS = exports.MAX_SUGGESTED_AMOUNTS_PER_FREQUENCY = exports.MAX_DONATION_FORM_FREQUENCIES = exports.ORG_PAGE_CONTACT_MESSAGE_MAX_LENGTH = exports.ORG_PAGE_SOURCE = exports.SOURCE_QUERY_PARAM_KEY = exports.MAX_PAYMENT_AMOUNT = void 0;
exports.MAX_PAYMENT_AMOUNT = 23_000_00;
exports.SOURCE_QUERY_PARAM_KEY = "source";
exports.ORG_PAGE_SOURCE = "org-page";
exports.ORG_PAGE_CONTACT_MESSAGE_MAX_LENGTH = 2_000;
exports.MAX_DONATION_FORM_FREQUENCIES = 4;
exports.MAX_SUGGESTED_AMOUNTS_PER_FREQUENCY = 4;
exports.SUGGESTED_AMOUNTS_COUNT_OPTIONS = [0, 2, 3, 4];
exports.DEFAULT_SUGGESTED_AMOUNTS_COUNT = 4;
exports.MAX_PAYMENT_AMOUNT_WITHOUT_TIP = 20_000_00;
exports.SEPA_MAX_PAYMENT_AMOUNT = 10_000_00;
exports.DEFAULT_CHEQUE_MINIMUM_AMOUNT = 1_000_00;
exports.AUCTION_CASH_CHEQUE_MINIMUM_AMOUNT = 0;
